<template>
  <div class="mx-4 legal-sidebar">
    <div class="personal-info-height">
      <v-btn block text class="py-6 mb-3 mt-6" @click="goPersonalAccount">
        <div class="d-flex justify-space-between full-width">
          <div class="d-flex">
            <div class="me-2">
              <v-icon clr="var(--v-gray1-base)">$shieldProtected</v-icon>
            </div>
            <div class="d-flex flex-column align-start">
              <span class="font-Medium-12 gray1--text">
                {{ $t("corporateAccount.sidebar.personalAccountSignin") }}
              </span>
              <span
                class="font-Regular-10 gray2--text text-truncate"
                style="width: 200px;"
              >
                {{ $t("corporateAccount.sidebar.managePasswordUsername2FA") }}
              </span>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-icon
              :class="{ 'transfor-x': !$vuetify.rtl }"
              clr="var(--v-gray1-base)"
              >$arrow24</v-icon
            >
          </div>
        </div>
      </v-btn>
      <v-btn
        block
        text
        class="py-6 mb-3 mt-6"
        style="background-color: #500FE91A;"
        to="/legal-entity/dashboard"
      >
        <div class="d-flex justify-space-between full-width">
          <div class="d-flex">
            <div class="me-2">
              <v-icon clr="var(--v-gray1-base)">$companyIcon</v-icon>
            </div>
            <div class="d-flex flex-column align-start">
              <span class="font-Medium-12 gray1--text">
                {{ $t("corporateAccount.sidebar.legalAccountDashboard") }}
              </span>
              <span
                class="font-Regular-10 gray2--text text-truncate"
                style="width: 200px;"
              >
                {{ $t("corporateAccount.sidebar.managePasswordUsername2FA") }}
              </span>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-icon
              :class="{ 'transfor-x': !$vuetify.rtl }"
              clr="var(--v-gray1-base)"
              >$arrow24</v-icon
            >
          </div>
        </div>
      </v-btn>
      <v-btn
        block
        text
        class="py-6 mb-3 mt-6"
        to="/legal-entity/permissions-cartable"
      >
        <div class="d-flex justify-space-between full-width">
          <div class="d-flex">
            <div class="me-2">
              <v-icon clr="var(--v-gray1-base)">$companyIcon</v-icon>
            </div>
            <div class="d-flex flex-column align-start">
              <span class="font-Medium-12 gray1--text">
                {{ $t("corporateAccount.sidebar.signatureCartable") }}
              </span>
              <span
                class="font-Regular-10 gray2--text text-truncate"
                style="width: 200px;"
              >
                {{ $t("corporateAccount.sidebar.viewLicensesForRequests") }}
              </span>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-icon
              :class="{ 'transfor-x': !$vuetify.rtl }"
              clr="var(--v-gray1-base)"
              >$arrow24</v-icon
            >
          </div>
        </div>
      </v-btn>
      <v-btn
        block
        text
        class="py-6 mb-3 mt-6"
        to="/history/transaction/deposits"
      >
        <div class="d-flex justify-space-between full-width">
          <div class="d-flex">
            <div class="me-2">
              <v-icon clr="var(--v-gray1-base)">$userVerifyPrimary</v-icon>
            </div>
            <div class="d-flex flex-column align-start">
              <span class="font-Medium-12 gray1--text">
                {{ $t("corporateAccount.sidebar.manageTransactions") }}
              </span>
              <span
                class="font-Regular-10 gray2--text text-truncate"
                style="width: 200px;"
              >
                {{ $t("corporateAccount.sidebar.personalContactAndIDPhoto") }}
              </span>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-icon
              :class="{ 'transfor-x': !$vuetify.rtl }"
              clr="var(--v-gray1-base)"
              >$arrow24</v-icon
            >
          </div>
        </div>
      </v-btn>
      <v-btn block text class="py-6 mb-3 mt-6" to="/account/banking">
        <div class="d-flex justify-space-between full-width">
          <div class="d-flex">
            <div class="me-2">
              <v-icon clr="var(--v-gray1-base)">$bankCustomer</v-icon>
            </div>
            <div class="d-flex flex-column align-start">
              <span class="font-Medium-12 gray1--text">
                {{ $t("corporateAccount.sidebar.bankInfoAndAddresses") }}
              </span>
              <span
                class="font-Regular-10 gray2--text text-truncate"
                style="width: 200px;"
              >
                {{
                  $t("corporateAccount.sidebar.walletAddressesAndBankAccounts")
                }}
              </span>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-icon
              :class="{ 'transfor-x': !$vuetify.rtl }"
              clr="var(--v-gray1-base)"
              >$arrow24</v-icon
            >
          </div>
        </div>
      </v-btn>
      <v-btn
        block
        text
        class="py-6 mb-3 mt-6"
        to="/account/company-information"
      >
        <div class="d-flex justify-space-between full-width">
          <div class="d-flex">
            <div class="me-2">
              <v-icon clr="var(--v-gray1-base)">$shieldProtected</v-icon>
            </div>
            <div class="d-flex flex-column align-start">
              <span class="font-Medium-12 gray1--text">
                {{ $t("corporateAccount.sidebar.identityInformation") }}
              </span>
              <span
                class="font-Regular-10 gray2--text text-truncate"
                style="width: 200px"
              >
                {{ $t("corporateAccount.sidebar.managePasswordUsername2FA") }}
              </span>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-icon
              :class="{ 'transfor-x': !$vuetify.rtl }"
              clr="var(--v-gray1-base)"
              >$arrow24</v-icon
            >
          </div>
        </div>
      </v-btn>
      <v-btn block text class="py-6 mb-3" to="/tickets">
        <div class="d-flex justify-space-between full-width">
          <div class="d-flex">
            <div class="me-2">
              <v-icon color="gray1" clr="var(--v-gray1-base)"
                >mdi-headset</v-icon
              >
            </div>
            <div class="d-flex flex-column align-start">
              <span class="font-Medium-12 gray1--text">
                {{ $t("accountPage.accountSidebar.links.ticketing.title") }}
              </span>
              <span class="font-Regular-10 gray2--text">{{
                $t("accountPage.accountSidebar.links.ticketing.description")
              }}</span>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-icon
              :class="{ 'transfor-x': !$vuetify.rtl }"
              clr="var(--v-gray1-base)"
              >$arrow24</v-icon
            >
          </div>
        </div>
      </v-btn>
      <!--      ورود به سایر حساب های حقوقی     -->
      <!--      <v-expansion-panels-->
      <!--        v-model="panel"-->
      <!--        flat-->
      <!--        accordion-->
      <!--        class="custom-expansion primary1 mb-6"-->
      <!--      >-->
      <!--        <v-expansion-panel>-->
      <!--          <v-expansion-panel-header>-->
      <!--            <div class="me-2" style="flex: 0">-->
      <!--              <v-icon clr="var(&#45;&#45;v-gray1-base)">$companyIcon</v-icon>-->
      <!--            </div>-->
      <!--            <div class="d-flex flex-column align-start">-->
      <!--              <span class="font-Medium-12 gray1&#45;&#45;text"-->
      <!--                >ورود به سایر حساب های حقوقی</span-->
      <!--              >-->
      <!--              <span class="font-Regular-10 gray2&#45;&#45;text mt-2"-->
      <!--                >امکان ورود به ستیر حساب های حقوقی شما</span-->
      <!--              >-->
      <!--            </div>-->
      <!--            <template v-slot:actions>-->
      <!--              <div class="d-flex align-center">-->
      <!--                <v-icon-->
      <!--                  :class="{-->
      <!--                    'transfor-x': !$vuetify.rtl,-->
      <!--                    'transform-arrow-down': panel === 0-->
      <!--                  }"-->
      <!--                  clr="var(&#45;&#45;v-gray1-base)"-->
      <!--                  >$arrow24</v-icon-->
      <!--                >-->
      <!--              </div>-->
      <!--            </template>-->
      <!--          </v-expansion-panel-header>-->
      <!--          <v-divider></v-divider>-->
      <!--          <v-expansion-panel-content v-for="item in 5" :key="item">-->
      <!--            <v-btn block text class="mt-4" to="/legal-entity-manage">-->
      <!--              <div class="d-flex justify-space-between full-width">-->
      <!--                <div class="d-flex">-->
      <!--                  <div class="d-flex flex-column align-start">-->
      <!--                    <span class="font-Medium-12 gray1&#45;&#45;text">-->
      <!--                      شرکت شماره یک-->
      <!--                    </span>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--                <div class="d-flex align-center">-->
      <!--                  <v-icon-->
      <!--                    :class="{ 'transfor-x': !$vuetify.rtl }"-->
      <!--                    clr="var(&#45;&#45;v-gray1-base)"-->
      <!--                    >$arrow24</v-icon-->
      <!--                  >-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </v-btn>-->
      <!--          </v-expansion-panel-content>-->
      <!--        </v-expansion-panel>-->
      <!--      </v-expansion-panels>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "LegalAccountSidebar",
  data() {
    return {
      panel: 0
    };
  },
  methods: {
    goPersonalAccount() {
      this.$cookies.remove("isLegal");
      this.$cookies.remove("CA_ID");
      this.$cookies.set("showAlert", "false");
      window.location = "/panel/dashboard";
    }
  }
};
</script>

<style lang="scss">
.full-width {
  width: 100%;
}
//.legal-sidebar .custom-expansion .v-expansion-panel {
//  background-color: transparent !important;
//
//  .v-expansion-panel-header {
//    padding: 24px 18px;
//  }
//}
</style>
